(window as any).__zone_symbol__PASSIVE_EVENTS = ['scroll', 'touchstart', 'click', 'touchend', 'touchcancel', 'touchmove'];
(window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove'];
(window as any).__Zone_disable_requestAnimationFrame = true;
